var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.1,139.1l0,0-5.5-36.44L137.3,106l-8.13,5.24s-9.7,7.61-9.7,8.39,16.41,28.24,16.41,28.24A30.42,30.42,0,0,0,159.1,139.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.39,104.71a62.24,62.24,0,0,1,2.36,7.34c.52,2.62,7.6,7.08,8.38,7.34s1.31-8.39,1.31-8.39l-2.09-10.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.42,92.67s2.25,9.37,7.08,14,10,4.67,11.79-3.58c1.47-6.8-2.18-15.87-2.18-15.87S125.33,77.52,120.42,92.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.47,119.65l-9.07,36.5L137,163.69l1.31-4.72-17.47-8.06,5.93-21s-.78-3.93-5-8.38",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "194.26 130.61 174.12 126.38 153.55 102.61 156.59 121.73 169.21 133.75 194.57 134.91 194.26 130.61",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385,332.29H130.79a5.62,5.62,0,0,1-5.62-5.62V184.43a5.62,5.62,0,0,1,5.62-5.62h.69a5.65,5.65,0,0,0,5.23-3.54l3.87-9.73a5.47,5.47,0,0,1,2.25-2.7,7.2,7.2,0,0,1,3.64-1h65.34a7.22,7.22,0,0,1,2.57.47,5.45,5.45,0,0,1,2.7,2.36L223.73,176a5.62,5.62,0,0,0,4.85,2.78H385a5.62,5.62,0,0,1,5.62,5.62V326.67A5.62,5.62,0,0,1,385,332.29Z",
    style: {
      fill: "#3C0E99",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 117.2,
    y: 246.41,
    width: 281.38,
    height: 174.43,
    rx: 5.27,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.27,231.76l-2.36-7.06-2.65-3.63a.36.36,0,0,0-.66.22v10.46l2,2.63Z",
    style: {
      fill: "#3C0E99",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-9--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.86,244a10.76,10.76,0,0,0-2,4.09c-.29,1.92.17,9.31.17,9.31l-10.3,1.16s.78-7.51.82-8.76A11.14,11.14,0,0,1,435,242.4C438.54,240.66,441.55,241.51,440.86,244Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0039600000000002px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-10--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443,245.27c8.54-11.28-12.05-23-17.46-11.79a21.12,21.12,0,0,0-1.78,4.36c-.82.5-3,1.84-3.4,2.21s1,1.32,1.77,1.79c-1.47,3.61-1.25,7.41-.83,8.27.73,1.48,4.33,1.5,6.7,1.06s3.31-2.71,4-3.33,4.13.17,5.34.53S441.34,247.5,443,245.27Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-11--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.72,260.29s-4.73,5.35-6.61,7.55-1.89,25.81-1.89,29.28-1.88,12.89,1.26,14.78,22.35,1.26,24.24-1.89,3.14-40.91,2.83-44.37a9.63,9.63,0,0,0-5.36-7.24C439,257.39,426.72,260.29,426.72,260.29Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.07,87.43c-49.5-28.29-93.34-5-115.27,19.8S224.53,157.08,197,161.68s-69.3-7.07-100.42,14.85-31,80.14-6.36,113.15,88.39,48.79,161.94,59.4a193.9,193.9,0,0,0,79.11-4.39l33.41-12.13c16.32-7.45,30-15.84,41.58-22.65,17.62-10.4,23.83-35.75,27.2-54.32a223.69,223.69,0,0,0-1.25-84C424.83,136.73,408,104.52,378.07,87.43Z",
    style: {
      fill: "#3C0E99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.07,87.43c-49.5-28.29-93.34-5-115.27,19.8S224.53,157.08,197,161.68s-69.3-7.07-100.42,14.85-31,80.14-6.36,113.15,88.39,48.79,161.94,59.4a193.9,193.9,0,0,0,79.11-4.39l33.41-12.13c16.32-7.45,30-15.84,41.58-22.65,17.62-10.4,23.83-35.75,27.2-54.32a223.69,223.69,0,0,0-1.25-84C424.83,136.73,408,104.52,378.07,87.43Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.74,122.08C452.62,103.6,440,97.54,432,106.34a15.62,15.62,0,0,0-2.87,16c2.81,7.59,7.64,21.06,10.52,31.6,4.24,15.56,2.82,27.58,7.77,21.22S455.15,145.42,453.74,122.08Z",
    style: {
      fill: "#3C0E99",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.74,122.08C452.62,103.6,440,97.54,432,106.34a15.62,15.62,0,0,0-2.87,16c2.81,7.59,7.64,21.06,10.52,31.6,4.24,15.56,2.82,27.58,7.77,21.22S455.15,145.42,453.74,122.08Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.18,119.25c7.77-1.41,17.67-19.8,30.4-27.58S272,78.23,260,83.89c0,0-9.2,2.12-16.27,16.27S232.4,120.66,240.18,119.25Z",
    style: {
      fill: "#3C0E99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.18,119.25c7.77-1.41,17.67-19.8,30.4-27.58S272,78.23,260,83.89c0,0-9.2,2.12-16.27,16.27S232.4,120.66,240.18,119.25Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.45,109.35c6.31-2.53,13.19-19.71,6-18.83a5.34,5.34,0,0,0-4.15,3.2C227,98.83,221.77,111.62,227.45,109.35Z",
    style: {
      fill: "#3C0E99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.45,109.35c6.31-2.53,13.19-19.71,6-18.83a5.34,5.34,0,0,0-4.15,3.2C227,98.83,221.77,111.62,227.45,109.35Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 265.98,
    cy: 421.67,
    rx: 202.32,
    ry: 7.52,
    style: {
      fill: "#3C0E99"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 265.98,
    cy: 421.67,
    rx: 202.32,
    ry: 7.52,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ladder--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.22,139a1.5,1.5,0,0,0-1.5,1.5v7.69H334.31v-7.69a1.5,1.5,0,1,0-3,0V334.2a1.5,1.5,0,0,0,3,0V290.87h27.41V334.2a1.5,1.5,0,1,0,3,0V140.47A1.5,1.5,0,0,0,363.22,139Zm-1.5,148.9H334.31v-9.72h27.41Zm0-12.73H334.31v-9.71h27.41Zm0-12.72H334.31v-9.68h27.41Zm0-12.71H334.31v-9.64h27.41Zm0-12.7H334.31v-9.53h27.41Zm0-12.66H334.31v-9.59h27.41Zm0-12.6H334.31v-9.68h27.41Zm0-12.72H334.31v-9.68h27.41Zm0-12.69H334.31v-9.71h27.41Zm0-12.72H334.31v-9.73h27.41Zm0-12.73H334.31v-9.73h27.41Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.58,295.16s22.45-30.73,11.5-38c-11.39-7.51-16.74,15.24-19.15,26.41-5.14,23.84-3.69,28.9-.24,23.66Z",
    style: {
      fill: "#3C0E99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.58,295.16s22.45-30.73,11.5-38c-11.39-7.51-16.74,15.24-19.15,26.41-5.14,23.84-3.69,28.9-.24,23.66Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,314.06s31.21-21.78,23.2-32.16c-8.33-10.81-20.78,9-26.69,18.76-12.61,20.88-12.87,26.14-7.91,22.3Z",
    style: {
      fill: "#3C0E99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,314.06s31.21-21.78,23.2-32.16c-8.33-10.81-20.78,9-26.69,18.76-12.61,20.88-12.87,26.14-7.91,22.3Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.68,339.32s27-12.13,22.39-21.23c-4.8-9.47-17.19,3.85-23.12,10.47-12.67,14.14-13.63,18.12-9.28,15.91Z",
    style: {
      fill: "#3C0E99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.68,339.32s27-12.13,22.39-21.23c-4.8-9.47-17.19,3.85-23.12,10.47-12.67,14.14-13.63,18.12-9.28,15.91Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.28,364.69s27-12.13,22.4-21.23c-4.81-9.46-17.19,3.85-23.13,10.48-12.66,14.14-13.63,18.12-9.27,15.9Z",
    style: {
      fill: "#3C0E99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.28,364.69s27-12.13,22.4-21.23c-4.81-9.46-17.19,3.85-23.13,10.48-12.66,14.14-13.63,18.12-9.27,15.9Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.61,308s-29.68-23.83-37.39-13.23c-8,11,14.46,17.43,25.51,20.35,23.58,6.23,28.7,5,23.62,1.32Z",
    style: {
      fill: "#3C0E99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.61,308s-29.68-23.83-37.39-13.23c-8,11,14.46,17.43,25.51,20.35,23.58,6.23,28.7,5,23.62,1.32Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.49,327.91s-33.82-17.46-39.27-5.53c-5.67,12.41,17.63,14.21,29,14.87,24.35,1.42,29.13-.8,23.42-3.4Z",
    style: {
      fill: "#3C0E99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.49,327.91s-33.82-17.46-39.27-5.53c-5.67,12.41,17.63,14.21,29,14.87,24.35,1.42,29.13-.8,23.42-3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.58,350.23s-29-14-33.33-3.77c-4.51,10.63,15.23,11.61,24.9,11.9C99.77,359,103.76,357,98.87,355Z",
    style: {
      fill: "#3C0E99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.58,350.23s-29-14-33.33-3.77c-4.51,10.63,15.23,11.61,24.9,11.9C99.77,359,103.76,357,98.87,355Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,368.26s-27.36-17-32.75-7.29c-5.61,10.09,13.92,13.16,23.5,14.48,20.44,2.82,24.61,1.27,20-1.3Z",
    style: {
      fill: "#3C0E99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,368.26s-27.36-17-32.75-7.29c-5.61,10.09,13.92,13.16,23.5,14.48,20.44,2.82,24.61,1.27,20-1.3Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.41,277.81s-5.14-44.63-22-40.07C46.9,242.5,61.56,265.08,69,276c15.81,23.24,21.63,25.8,20.38,18.54Z",
    style: {
      fill: "#3C0E99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.41,277.81s-5.14-44.63-22-40.07C46.9,242.5,61.56,265.08,69,276c15.81,23.24,21.63,25.8,20.38,18.54Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.86,254S93.52,302.08,97.5,324.4c4.58,25.64,5.32,54.28,2.16,76.72",
    style: {
      fill: "none",
      stroke: "#3C0E99",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.45,
    y1: 309.55,
    x2: 106.02,
    y2: 271.05,
    style: {
      fill: "none",
      stroke: "#3C0E99",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.5,
    y1: 324.4,
    x2: 121.16,
    y2: 294.65,
    style: {
      fill: "none",
      stroke: "#3C0E99",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.99,
    y1: 318.99,
    x2: 61.73,
    y2: 304.6,
    style: {
      fill: "none",
      stroke: "#3C0E99",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.47,
    y1: 344.55,
    x2: 126.23,
    y2: 324.81,
    style: {
      fill: "none",
      stroke: "#3C0E99",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.1,
    y1: 336.08,
    x2: 72.19,
    y2: 330.48,
    style: {
      fill: "none",
      stroke: "#3C0E99",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.39,
    y1: 356.69,
    x2: 79.55,
    y2: 353.39,
    style: {
      fill: "none",
      stroke: "#3C0E99",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102.15,
    y1: 370.03,
    x2: 116.17,
    y2: 357.47,
    style: {
      fill: "none",
      stroke: "#3C0E99",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.87,
    y1: 375.68,
    x2: 77.92,
    y2: 369.66,
    style: {
      fill: "none",
      stroke: "#3C0E99",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.13 383.01 112.44 383.01 112.44 388.87 109.97 388.87 104.86 420.84 91.71 420.84 86.6 388.87 84.13 388.87 84.13 383.01",
    style: {
      fill: "#3C0E99"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.13 383.01 112.44 383.01 112.44 388.87 109.97 388.87 104.86 420.84 91.71 420.84 86.6 388.87 84.13 388.87 84.13 383.01",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.75,81.12a9.22,9.22,0,0,0-9.18-1.83c-5.5,1.83-10.77,9.78-9.44,16.51.93,4.66,5.25,11.53,6.56,14.15S118.16,117,114,126.2s-5.77,17.83,6.29,25.43S146,147.17,153,138.52s-5.25-28.57-6.3-37S143.85,76.93,130.75,81.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.1,139.1A28.88,28.88,0,0,1,136,147.44l-2.89,12.05L138.61,187l35.91-18.61-8.13-21Z",
    style: {
      fill: "#3C0E99",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.1,139.1A28.88,28.88,0,0,1,136,147.44l-2.89,12.05L138.61,187l35.91-18.61-8.13-21Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.1,139.1l0,0-5.5-36.44L137.3,106l-8.13,5.24s-9.7,7.61-9.7,8.39,16.41,28.24,16.41,28.24A30.42,30.42,0,0,0,159.1,139.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-1--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.39,147.44l-7.34-8.39-5.5-36.44L137.3,106l-3.84,2.48L134.68,125a9.61,9.61,0,0,0,3.24,1.16c1.16,0,2.09-2.55,2.09-2.55l1.39-2.32a5.1,5.1,0,0,0,5.34.47c3.24-1.4,1.39-6.5.92-8.35s4.41-.7,4.41-.7,3.94,8.58,4.41,11.36-2.09,10.44-1.86,12.07.23,4.63-.69,5.56-4.18,6-4.18,6,13.69,1.16,15.08,1.16a11.76,11.76,0,0,0,2-.39Z",
    style: {
      fill: "none",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M159.1,139.1l0,0-5.5-36.44L137.3,106l-8.13,5.24s-9.7,7.61-9.7,8.39,16.41,28.24,16.41,28.24A30.42,30.42,0,0,0,159.1,139.1Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.23,137.54s11.49-8.52,10.43-6-9,8.81-11.13,9S137.23,137.54,137.23,137.54Z",
    style: {
      fill: "#3C0E99",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "137.58 121.36 138.03 121.83 140.83 124.79 141.55 136.16 144.98 135.62 142.27 124.97 146.61 133.99 150.22 130.38 142.46 123.34 142.27 117.75 138.3 115.76",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.27,107.86s-3.41,1.57-3.41,4.71,3.69,10.61,6,12.18,6.27-5.62,6.27-5.62,6,2.88,7.6.26-3.67-11.27-7.07-13.63S131.27,107.86,131.27,107.86Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.39,104.71a62.24,62.24,0,0,1,2.36,7.34c.52,2.62,7.6,7.08,8.38,7.34s1.31-8.39,1.31-8.39l-2.09-10.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-1--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.57,101.87a10.16,10.16,0,0,0-1.34-.28L130,104.14l-.95,2.48c.48,1.34,1.09,3.14,1.46,4.6a8.05,8.05,0,0,0,4.13,1.73c2.17.15,4.08-1.53,5.43-3.59Z",
    style: {
      fill: "#3C0E99",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128.39,104.71a62.24,62.24,0,0,1,2.36,7.34c.52,2.62,7.6,7.08,8.38,7.34s1.31-8.39,1.31-8.39l-2.09-10.22Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.67,100.25s-2.89-2.35-2.89,0,2.63,3.67,4.72,3.67",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.13,92.65s1.84-2.88,2.36.27a8,8,0,0,1-1.57,5.76Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.67,100.25s-2.89-2.35-2.89,0,2.63,3.67,4.72,3.67",
    style: {
      fill: "#3C0E99",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.13,92.65s1.84-2.88,2.36.27a8,8,0,0,1-1.57,5.76Z",
    style: {
      fill: "#3C0E99",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.42,92.67s2.25,9.37,7.08,14,10,4.67,11.79-3.58c1.47-6.8-2.18-15.87-2.18-15.87S125.33,77.52,120.42,92.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-1--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.81,84.17l1.83,4.6s2.88-.64,4.5,2.84,3.25,8.58,2.32,12.53c-.89,3.76-3,5-6.25,5.09,3.54,1.51,6.75,0,8.08-6.16,1.47-6.8-2.18-15.87-2.18-15.87S133.12,83.93,128.81,84.17Z",
    style: {
      fill: "#3C0E99",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120.42,92.67s2.25,9.37,7.08,14,10,4.67,11.79-3.58c1.47-6.8-2.18-15.87-2.18-15.87S125.33,77.52,120.42,92.67Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.36,97.62c.28.53.23,1.1-.11,1.28s-.84-.11-1.11-.64-.23-1.09.11-1.27S129.09,97.1,129.36,97.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.58,96c.2.56.07,1.12-.29,1.24s-.82-.22-1-.78-.07-1.12.29-1.24S134.38,95.46,134.58,96Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.94,93a2.25,2.25,0,0,0-2.72.16c-1.44,1.12,1.28,6.73,1.28,6.73s.05,1.77-2.22.95",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.94,102.66a2.58,2.58,0,0,1-4,1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.85,94.49s-2.56-2.41-3.68,2.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.26,84.25c-2.81-2.44-5.08-2.41-6.07-2.09a6.71,6.71,0,0,0-3.07-1c-7.86-1.05-8.91,5-8.91,10.75s-5,12.58-1.57,13.37a4.1,4.1,0,0,0,4.72-2.36s3.67-6,3.67-10.23,4.57-3.83,4.57-3.83l0,0a2.44,2.44,0,0,1,3.68-.42c2.08,1.78,2.32,3.87,4,4.41s4.49-2.16,4.49-2.16A39.56,39.56,0,0,0,137.26,84.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.82,85.82s-3.16-2.54-6,.31-2.53,8.24-3.48,11.73-3.49,4.12-3.49,4.12",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.61,84.87s-3.41-3.38-7.7.9c-3.27,3.28-1.81,5.43-2.45,10.82",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.41,84.23s6-2.85,8.56,4.44",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.47,119.65l-9.07,36.5L137,163.69l1.31-4.72-17.47-8.06,5.93-21s-.78-3.93-5-8.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-1--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.35,159l-17.47-8.06,5.93-21a16.12,16.12,0,0,0-2.23-4.89l-.57-.43v5.8c0,3.71-4.64,15.54-6.27,18.32s-4.17,6.26-4.17,6.26l5.1-2.32L138,160.42Z",
    style: {
      fill: "#3C0E99",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.47,119.65l-9.07,36.5L137,163.69l1.31-4.72-17.47-8.06,5.93-21s-.78-3.93-5-8.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.26 130.61 174.12 126.38 153.55 102.61 156.59 121.73 169.21 133.75 194.57 134.91 194.26 130.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-1--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.55,102.61,156,117.87l1.56,4.77.2.18c.59-.61,3.92-4.07,4.77-4.07s10.44,8.35,9.05,9l-1.4.69,23.89,3.94.17-1.83-20.1-4.22Z",
    style: {
      fill: "#3C0E99",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "194.26 130.61 174.12 126.38 153.55 102.61 156.59 121.73 169.21 133.75 194.57 134.91 194.26 130.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.27,333,125.8,295.42a3.11,3.11,0,0,1-2.62-3.53l21.36-145.71a3.1,3.1,0,0,1,3.52-2.62l4.86.71a3.09,3.09,0,0,0,3.14-1.52l6.45-11.15a2.94,2.94,0,0,1,.78-.9,7.15,7.15,0,0,1,5.23-1.28l64.65,9.48a7.14,7.14,0,0,1,3.87,1.86,3,3,0,0,1,.66,1L243.45,156a3.09,3.09,0,0,0,2.43,1.91l158.65,23.26a3.11,3.11,0,0,1,2.63,3.52L385.8,330.39A3.11,3.11,0,0,1,382.27,333Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,332.29H130.79a5.62,5.62,0,0,1-5.62-5.62V184.43a5.62,5.62,0,0,1,5.62-5.62h.69a5.65,5.65,0,0,0,5.23-3.54l3.87-9.73a5.47,5.47,0,0,1,2.25-2.7,7.2,7.2,0,0,1,3.64-1h65.34a7.22,7.22,0,0,1,2.57.47,5.45,5.45,0,0,1,2.7,2.36L223.73,176a5.62,5.62,0,0,0,4.85,2.78H385a5.62,5.62,0,0,1,5.62,5.62V326.67A5.62,5.62,0,0,1,385,332.29Z",
    style: {
      fill: "#3C0E99"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-1--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385,332.29H130.79a5.62,5.62,0,0,1-5.62-5.62V184.43a5.62,5.62,0,0,1,5.62-5.62h.69a5.65,5.65,0,0,0,5.23-3.54l3.87-9.73a5.47,5.47,0,0,1,2.25-2.7,7.2,7.2,0,0,1,3.64-1h65.34a7.22,7.22,0,0,1,2.57.47,5.45,5.45,0,0,1,2.7,2.36L223.73,176a5.62,5.62,0,0,0,4.85,2.78H385a5.62,5.62,0,0,1,5.62,5.62V326.67A5.62,5.62,0,0,1,385,332.29Z",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M385,332.29H130.79a5.62,5.62,0,0,1-5.62-5.62V184.43a5.62,5.62,0,0,1,5.62-5.62h.69a5.65,5.65,0,0,0,5.23-3.54l3.87-9.73a5.47,5.47,0,0,1,2.25-2.7,7.2,7.2,0,0,1,3.64-1h65.34a7.22,7.22,0,0,1,2.57.47,5.45,5.45,0,0,1,2.7,2.36L223.73,176a5.62,5.62,0,0,0,4.85,2.78H385a5.62,5.62,0,0,1,5.62,5.62V326.67A5.62,5.62,0,0,1,385,332.29Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,178.33H156.32a3.66,3.66,0,0,1-3.66-3.66h0a3.66,3.66,0,0,1,3.66-3.67H197a3.67,3.67,0,0,1,3.67,3.67h0A3.66,3.66,0,0,1,197,178.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,357.11H130.79a5.62,5.62,0,0,1-5.62-5.62V209.25a5.62,5.62,0,0,1,5.62-5.62h.69a5.64,5.64,0,0,0,5.23-3.54l3.87-9.72a5.43,5.43,0,0,1,2.25-2.7,7.11,7.11,0,0,1,3.64-1h65.34a7.22,7.22,0,0,1,2.57.47,5.42,5.42,0,0,1,2.7,2.37l6.65,11.34a5.62,5.62,0,0,0,4.85,2.78H385a5.62,5.62,0,0,1,5.62,5.62V351.49A5.62,5.62,0,0,1,385,357.11Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.49,149l-40.36-5a3.68,3.68,0,0,1-3.19-4.09h0a3.67,3.67,0,0,1,4.1-3.18l40.35,5a3.67,3.67,0,0,1,3.19,4.09h0A3.66,3.66,0,0,1,216.49,149Z",
    style: {
      fill: "#3C0E99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.49,149l-40.36-5a3.68,3.68,0,0,1-3.19-4.09h0a3.67,3.67,0,0,1,4.1-3.18l40.35,5a3.67,3.67,0,0,1,3.19,4.09h0A3.66,3.66,0,0,1,216.49,149Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,203.16H156.32a3.66,3.66,0,0,1-3.66-3.67h0a3.67,3.67,0,0,1,3.66-3.67H197a3.67,3.67,0,0,1,3.67,3.67h0A3.67,3.67,0,0,1,197,203.16Z",
    style: {
      fill: "#3C0E99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,203.16H156.32a3.66,3.66,0,0,1-3.66-3.67h0a3.67,3.67,0,0,1,3.66-3.67H197a3.67,3.67,0,0,1,3.67,3.67h0A3.67,3.67,0,0,1,197,203.16Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.2,
    y: 246.41,
    width: 281.38,
    height: 174.43,
    rx: 5.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-1--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.58,293.36a421.52,421.52,0,0,1-105.1,71.9c-56.85,27.19-121.83,45.93-159.69,55.58H393.3a5.27,5.27,0,0,0,5.28-5.27Z",
    style: {
      fill: "#3C0E99",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.58,293.36a421.52,421.52,0,0,1-105.1,71.9c-56.85,27.19-121.83,45.93-159.69,55.58H393.3a5.27,5.27,0,0,0,5.28-5.27Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.2,
    y: 246.41,
    width: 281.38,
    height: 174.43,
    rx: 5.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.27,261.73v-7a5.28,5.28,0,0,1,5.28-5.27H138",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.27,
    y1: 368.04,
    x2: 121.27,
    y2: 270.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.5,401.4v11.07a5.27,5.27,0,0,1-5.27,5.28H380",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 394.5,
    y1: 259.27,
    x2: 394.5,
    y2: 393.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.32,
    y: 310.19,
    width: 89.13,
    height: 48.15,
    rx: 2.73,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.32,
    y: 310.19,
    width: 89.13,
    height: 14.64,
    rx: 2.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,163.69l1.83,3.41,3.89,2.8a1.51,1.51,0,0,0,1.7.06l.34-.22a1.19,1.19,0,0,0,.47-1.5l-2.21-5.08,1.49,1.16a1.15,1.15,0,0,0,1.59-.18h0a1.16,1.16,0,0,0,0-1.45l-3.47-4.39-4.34.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.8,
    y1: 169.74,
    x2: 141.32,
    y2: 165.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142.76,
    y1: 169.9,
    x2: 140.03,
    y2: 166.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.26,130.61l5.44.32,6.62,4.23s.37,1.29-.55,1.47-5.89-1.65-5.89-1.65l-5.31-.07Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.54,134.24l5.71,2.58s.92-1.29-.37-1.84L198,133.69",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.27,231.76l-2.36-7.06-2.65-3.63a.36.36,0,0,0-.66.22v10.46l2,2.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.73,262.63l-19.8.7a3.85,3.85,0,0,1-3.56-2.09l-15.1-29.48s-3.4,1.84-3.66,2.62,11.18,29.47,14.69,38.28a3.85,3.85,0,0,0,3.73,2.42l22.13-.94",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 397.72,
    y1: 235.43,
    x2: 394.62,
    y2: 236.71,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.73,262.63l-19.8.7a3.85,3.85,0,0,1-3.56-2.09l-15.1-29.48s-3.4,1.84-3.66,2.62,11.18,29.47,14.69,38.28a3.85,3.85,0,0,0,3.73,2.42l22.13-.94",
    style: {
      fill: "#3C0E99",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 397.72,
    y1: 235.43,
    x2: 394.62,
    y2: 236.71,
    style: {
      fill: "#3C0E99",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M396.27,231.76l-2.36-7.06-2.65-3.63a.36.36,0,0,0-.66.22v10.46l2,2.63Z",
    style: {
      fill: "#3C0E99"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-8--inject-1--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.27,231.76l-2.36-7.06-2.65-3.63a.36.36,0,0,0-.66.22v10.46l2,2.63Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M396.27,231.76l-2.36-7.06-2.65-3.63a.36.36,0,0,0-.66.22v10.46l2,2.63Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.86,244a10.76,10.76,0,0,0-2,4.09c-.29,1.92.17,9.31.17,9.31l-10.3,1.16s.78-7.51.82-8.76A11.14,11.14,0,0,1,435,242.4C438.54,240.66,441.55,241.51,440.86,244Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-9--inject-1--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.79,244.08c-1.87-.51-4.14-1.08-6.06-1.54a11.18,11.18,0,0,0-5.21,7.25c0,.48-.14,1.88-.28,3.42,1-.23,2.59-.58,3.77-.79a16.55,16.55,0,0,0,2.75-.69l-.35,6,.23,0,3.36-.38s-.46-7.39-.17-9.31A10.51,10.51,0,0,1,440.79,244.08Z",
    style: {
      fill: "#3C0E99",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M440.86,244a10.76,10.76,0,0,0-2,4.09c-.29,1.92.17,9.31.17,9.31l-10.3,1.16s.78-7.51.82-8.76A11.14,11.14,0,0,1,435,242.4C438.54,240.66,441.55,241.51,440.86,244Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0039600000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443,245.27c8.54-11.28-12.05-23-17.46-11.79a21.12,21.12,0,0,0-1.78,4.36c-.82.5-3,1.84-3.4,2.21s1,1.32,1.77,1.79c-1.47,3.61-1.25,7.41-.83,8.27.73,1.48,4.33,1.5,6.7,1.06s3.31-2.71,4-3.33,4.13.17,5.34.53S441.34,247.5,443,245.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-10--inject-1--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.55,244.19s.18.85-1.54,1.54-2.06.17-2.57,1.37a4.28,4.28,0,0,1-3.43,3.09,41.07,41.07,0,0,1-4.93.63c1.36.76,4.06.7,6,.35,2.36-.43,3.31-2.71,4-3.33s4.13.17,5.34.53a2.2,2.2,0,0,0,.86,0,9.38,9.38,0,0,0,.8-3.18Z",
    style: {
      fill: "#3C0E99",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M443,245.27c8.54-11.28-12.05-23-17.46-11.79a21.12,21.12,0,0,0-1.78,4.36c-.82.5-3,1.84-3.4,2.21s1,1.32,1.77,1.79c-1.47,3.61-1.25,7.41-.83,8.27.73,1.48,4.33,1.5,6.7,1.06s3.31-2.71,4-3.33,4.13.17,5.34.53S441.34,247.5,443,245.27Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.32,238.83c-.22.48-.59.78-.83.67s-.26-.59,0-1.07.59-.78.83-.67S426.54,238.35,426.32,238.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.12,235.75s1-.83,1.2,1.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.93,243.78s0,1,1.8,1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.49,309.22,418.7,319s-5.47,38.94-5.21,43.41.85,50.65.85,50.65l6.59,1.05,7.4-51.22,10.39-52.05Z",
    style: {
      fill: "#3C0E99",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.49,309.22,418.7,319s-5.47,38.94-5.21,43.41.85,50.65.85,50.65l6.59,1.05,7.4-51.22,10.39-52.05Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.83,344.79s-2.53,14.89-4.44,22.19-1.9,14.58-1.9,22.5S418.64,412,418.64,412",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.86,306.82c4.34-2.28,9-3.79,10.33-.76,2.64,6.06-.52,15.27-.52,15.27l2.41,42.48,4.41,51.25L442.9,414s-10.12-43.25-11.7-45.89-4.07-39.67-4.07-39.67l-5-4.55",
    style: {
      fill: "#3C0E99",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.86,306.82c4.34-2.28,9-3.79,10.33-.76,2.64,6.06-.52,15.27-.52,15.27l2.41,42.48,4.41,51.25L442.9,414s-10.12-43.25-11.7-45.89-4.07-39.67-4.07-39.67l-5-4.55",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M438,339c.15,9.85,1.15,14.59,1.93,17.19.95,3.17.63,9.19.63,12s-1.27-.63,1.59,12.37,4.75,31.06,4.75,31.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,317.53s.31-.64,0,14.26c0,.8,0,1.57,0,2.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "423.37 314.7 423.16 319.16 422.13 322.26 423.67 324.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.35,317.36s2.58,2.58,9.28,1.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.18,315.13c5-1,5.32-2.38,7.05-3.54a14.43,14.43,0,0,0-1-5.53c-1.31-3-6-1.52-10.33.76l-2.1,3.32-11.27-.92-.36,4.42A36.82,36.82,0,0,0,437.18,315.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.62 312.28 420.51 314.04 423.37 314.7 423.59 312.39 420.62 312.28",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "440.58 314.89 440.1 310.51 441.55 310.03 442.28 313.92",
    style: {
      fill: "#3C0E99",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "429.4 316.35 428.43 311.24 430.86 311.24 431.83 315.62",
    style: {
      fill: "#3C0E99",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "440.58 314.89 440.1 310.51 441.55 310.03 442.28 313.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "429.4 316.35 428.43 311.24 430.86 311.24 431.83 315.62",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M418.2,270.46s-.83,5.55-3.32,15-5,20.78-5,20.78l1.39,5.82,4.15-6.1Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.13,262.43s-5.82,1.38-6.37,4.15a23,23,0,0,0-.56,3.88l8.87-7.2,11.09-4.44Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.72,260.29s-4.73,5.35-6.61,7.55-1.89,25.81-1.89,29.28-1.88,12.89,1.26,14.78,22.35,1.26,24.24-1.89,3.14-40.91,2.83-44.37a9.63,9.63,0,0,0-5.36-7.24C439,257.39,426.72,260.29,426.72,260.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-11--inject-1--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.19,258.4a2.51,2.51,0,0,0-.82-.18l-1.36.71a12.9,12.9,0,0,1,4.46,7.38A39.23,39.23,0,0,1,443.3,279c-.68,4.63-11.66,0-9.6,1.72s9.77,4.63,10.12,6.17S440,291,438.5,291.18s1,3.6,2.57,6.51,1,7-2.57,9.78-11.86,4.15-15.44,4.29c-1.16,0-1.88.3-2.1.64,5.5,1.23,21.07.43,22.76-2.39,1.89-3.15,3.14-40.91,2.83-44.37A9.63,9.63,0,0,0,441.19,258.4Z",
    style: {
      fill: "#3C0E99",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M426.72,260.29s-4.73,5.35-6.61,7.55-1.89,25.81-1.89,29.28-1.88,12.89,1.26,14.78,22.35,1.26,24.24-1.89,3.14-40.91,2.83-44.37a9.63,9.63,0,0,0-5.36-7.24C439,257.39,426.72,260.29,426.72,260.29Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.39,284.24c-5.07-1.58-9.51-6-9.51-6a21.45,21.45,0,0,0,8.56,13",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.25 254.94 425.14 258.4 424.2 262.81 441.19 258.4 440.25 254.94",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.81 420.71 420.93 414.07 414.34 413.02 408.85 416.93 403.93 419.63 403.93 420.71 421.81 420.71",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.31 421.23 449.49 415.06 442.9 414 437.41 417.91 432.49 420.62 432.49 421.23 450.31 421.23",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.39,226l-4.06-2.35s-1.58-.19-.9,1.57l4.06,3.13",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.79,232.11a4.06,4.06,0,0,0-.83-1.3l-.76-.82,0,0-4.13-5.12s-1.28-.86-1,1l2.56,5-4.55-4.27s-.86-.71-.86.29,4.13,5.41,4.13,5.41l-4.56-2.14s-1,.71-.28,1.42,4.55,2.14,4.55,2.14l-3.41-.14s-1,.85-.29,1.14,4.7,1.13,4.7,1.13a5.68,5.68,0,0,0,1.71,1l1,1.85,3.83-1.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.68,276.5l-22.82,5.35a5.13,5.13,0,0,1-5.67-3.19l-14.4-40,3.83-1.93,15.91,29.47a3.56,3.56,0,0,0,3.84,1.81l17.45-4.93",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.68,276.5l-22.82,5.35a5.13,5.13,0,0,1-5.67-3.19l-14.4-40,3.83-1.93,15.91,29.47a3.56,3.56,0,0,0,3.84,1.81l17.45-4.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 396.77,
    y1: 240.5,
    x2: 392.33,
    y2: 242.72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.84,233.6s-2.43,2.43-1.22,4.25a12.11,12.11,0,0,1,1.62,3.43s-1,2.43-.2,2.43.4-1.82,1.82-1.41,2.83,2.83,1.62,3.64a13.82,13.82,0,0,1-2.86,1.2.68.68,0,0,0-.14,1.24,9.63,9.63,0,0,0,4.41,1.6,15.46,15.46,0,0,0,3.84-.4s4-5.46,6.88-6.88,1.62-7.89,1.62-8.7-2.83-2.63-2.83-2.63.81-1.82-2.83-5.86-10.52-4.86-10.72-3.44a2,2,0,0,0,.81,2s-6.07-2.63-8.9.2S430.84,233.6,430.84,233.6Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.84,233.6s4.92,6,12.21,6.58",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.1,235.43s2.29,6.66,11.76,8.56",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.a0def8107e23289ae3d34d682b5e5d20.svg";
export { ForwardRef as ReactComponent };